<template>
  <div class="container">
    <div class="tabs-box">
      <div class="tabs">
        <button
          :class="['tab', currentTab === 'SoSinhTu' ? 'active' : '']"
          @click="currentTab = 'SoSinhTu'"
        >
          Sổ Sinh Tử
        </button>
        <button
          :class="['tab', currentTab === 'TongKet' ? 'active' : '']"
          @click="currentTab = 'TongKet'"
        >
          Tổng Kết
        </button>
        <button
          :class="['tab', currentTab === 'LichSu' ? 'active' : '']"
          @click="currentTab = 'LichSu'"
        >
          Lịch Sử
        </button>
      </div>
</div>

    <div class="content">
      <SoSinhTu v-if="currentTab === 'SoSinhTu'" />
      <TongKet v-if="currentTab === 'TongKet'" />

      <!-- ✅ Lịch Sử nhận players -->
      <LichSu
        v-if="currentTab === 'LichSu'"
        :players="players"
        v-show="!isLoadingPlayers"
      />

    </div>
  </div>
</template>

<script>
import SoSinhTu from './components/SoSinhTu.vue'
import TongKet from './components/TongKet.vue'
import LichSu from './components/LichSu.vue'

export default {
  name: 'MainApp',
  components: {
    SoSinhTu,
    TongKet,
    LichSu
  },
  data() {
    return {
      currentTab: 'SoSinhTu',
      players: [],
      isLoadingPlayers: true
    }
  },
  created() {
    this.fetchPlayers()
  },
  methods: {
    async fetchPlayers() {
  try {
    const response = await fetch('https://script.google.com/macros/s/AKfycbzFo0bGYZHZc7I9FZAmBmixHtH6-u_M-eMC7QfEgNCGBq87KYHvIbn6H_Guh0YPAUkpkQ/exec?action=getPlayers')
    const data = await response.json()
    console.log("📦 Dữ liệu players API:", data)
    this.players = Array.isArray(data) ? data : data.data || []
  } catch (error) {
    console.error('Lỗi khi tải danh sách người chơi:', error)
  } finally {
    this.isLoadingPlayers = false
  }
}

  }
}
</script>

<style scoped>
.container {
  max-width: 480px;
  margin: 0 auto;
  font-family: sans-serif;
  padding-top: 10px;
}

.tabs-box {
  background: white;
  border-radius: 16px;
  padding: 10px 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border: 0.5px solid #e9e9e9;
  width: 100%;
}

.tabs {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.tab {
  padding: 10px 12px;
  font-weight: bold;
  border: none;
  background: none;
  border-bottom: 3px solid transparent;
  color: #888;
  font-size: 15px;
  cursor: pointer;
}

.tab.active {
  color: #88C100;
  position: relative;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 30%;
  width: 40%;
  height: 4px;
  background-color: #88C100;
  border-radius: 3px;
}

.content {
  margin-top: 15px;
  padding: 15px;
  background-color: white;
  max-width: 480px;
}
</style>
